import { Box, Card, Flex, SimpleGrid, Text } from '@chakra-ui/react';
// import MapView from 'components/detailMapData/MapView';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ViewPowerBankData } from 'reactRedux/thunks/powerBankThunk/powerBankThunk';
import PageLoader from '../../../components/wholePageLoader/PageLoader';
import BackButton from 'components/backButton/BackButton';
import { powerBankStatus } from 'utils/StaticData';

const PowerBankDetails = () => {
  const { powerbanksDetailId } = useParams();
  const dispatch = useDispatch();
  const { viewPowerbankDetails, isViewLoading } = useSelector(
    (state) => state.PowerBankSlice,
  );
  useEffect(() => {
    if (powerbanksDetailId) {
      dispatch(ViewPowerBankData({ id: powerbanksDetailId }));
    }
  }, [powerbanksDetailId, dispatch]);

  return (
    <>
      {isViewLoading ? (
        <PageLoader />
      ) : (
        <Box pt={{ base: '60px', md: '80px', xl: '80px' }}>
          <Flex mb={4}>
            <BackButton
              fallbackUrl="/admin/powerbanks"
              label="Back to Powerbanks"
            />
          </Flex>
          <Flex direction="column" align="center" justify="center">
            {viewPowerbankDetails ? (
              <>
                <Card
                  w="100%"
                  boxShadow="14px 17px 40px 4px rgba(112, 144, 176, 0.08)"
                  borderRadius="20px"
                  paddingInline="40px"
                  paddingBlock="40px"
                  overflowX={{ sm: 'scroll', lg: 'hidden' }}
                >
                  <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal">Powerbank Id :</Text>
                      <Text fontWeight="semibold">
                        {viewPowerbankDetails.powerbankId}
                      </Text>
                    </Flex>
                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal">Station Id :</Text>
                      <Text fontWeight="semibold">
                        {/* {viewPowerbankDetails.stationId ? viewPowerbankDetails.stationId : 'N/A'} */}
                        {viewPowerbankDetails.stationId
                          ? typeof viewPowerbankDetails.stationId === 'object'
                            ? viewPowerbankDetails.stationId.stationId
                            : viewPowerbankDetails.stationId
                          : 'N/A'}
                      </Text>
                    </Flex>

                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal">Slots :</Text>
                      <Text fontWeight="semibold">
                        {viewPowerbankDetails.slot
                          ? viewPowerbankDetails.slot
                          : 'N/A'}
                      </Text>
                    </Flex>

                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal">Battery Level :</Text>
                      <Text fontWeight="semibold">
                        {viewPowerbankDetails.batteryLevel
                          ? `${viewPowerbankDetails.batteryLevel} %`
                          : 'N/A'}
                      </Text>
                    </Flex>
                    <Flex
                      alignItems={{ sm: 'start', md: 'center' }}
                      direction={{ sm: 'column', md: 'row' }}
                      gap="10px"
                      padding="4px 8px"
                      borderLeft={'1px solid #ccc'}
                    >
                      <Text fontWeight="normal">Status :</Text>
                      <Text fontWeight="semibold">
                        {powerBankStatus[viewPowerbankDetails?.status] || 'N/A'}
                      </Text>
                    </Flex>
                    {/* <GridItem colSpan={{ base: 1, lg: 2 }}>
                      <Text fontWeight="normal" mb={2}>
                        Coordinates :
                      </Text>
                      <MapView
                        coordinates={
                          viewPowerbankDetails?.coordinates || [0, 0]
                        }
                      />
                    </GridItem> */}
                  </SimpleGrid>
                </Card>
              </>
            ) : (
              <Text>No powerbank details found.</Text>
            )}
          </Flex>
        </Box>
      )}
    </>
  );
};

export default PowerBankDetails;
